import React from "react";
import Icon from "../Icon/Icon";

export interface StarProps {
  full?: boolean;
  half?: boolean;
  size?: string;
}

const Star = ({ size = "1.5rem", half = false, full = false }: StarProps) => {
  return (
    <div className="relative flex flex-row items-center" style={{ width: size }}>
      <Icon
        strokeWidth="0.1rem"
        variants="halfstar"
        style={{
          width: size,
          height: size,
          fill: half ? "var(--gold)" : "#e3dfdb",
        }}
      />
      <Icon
        strokeWidth="0.1rem"
        variants="halfstar"
        className="absolute left-[-0.02rem] z-0"
        style={{
          width: size,
          height: size,
          fill: full ? "var(--gold)" : "#e3dfdb",
          transform: "scale(-1, 1)",
        }}
      />
    </div>
  );
};

export default Star;
